// src/pages/EventDetailPage.jsx
import React from "react";
import { useParams } from "react-router-dom";
import EventBinding from "../components/events/detail/EventBinding";

export default function EventDetailPage() {
  const { eventId } = useParams();

  if (!eventId) {
    return (
      <div className="py-20 text-center text-gray-500">
        잘못된 접근입니다.
      </div>
    );
  }

  return <EventBinding />;
}
